<template>
    <div class="container">
        <div class="columns is-8 is-variable">
            <div class="column is-one-quarter is-align-items-stretch">
                <div
                    @click="SET_IS_ACT_FINANCE_ACC(true)"
                    class="cta-cte card card-limit py-4 mb-5 modal-button has-background-flow"
                >
                    <CardTotalEntity
                        header="CUENTAS BANCARIAS"
                        :updated_at="lastUpdate"
                        :amount="totalFinanceAccounts"
                    />
                </div>
                <div class="card py-4">
                    <CardTotalTax
                        trending="trending_up"
                        header="Total por cobrar"
                        footer="A tus clientes"
                        :value="totalCollect"
                    />
                    <div class="horizontal-separator my-3"></div>
                    <CardTotalTax
                        trending="trending_down"
                        header="Total por pagar"
                        footer="A tus contrapartes"
                        :value="totalPay"
                    />
                </div>
            </div>
            <div class="column chart_column">
                <span
                    class="is-block has-text-weight-bold mb-0 is-size-5 has-text-left"
                >
                    Proyección de caja semanal
                </span>
                <p style="margin-bottom: 20px">Partimos de tu saldo actual y te mostramos los próximos 3 meses</p>
                <div class="chart_wrap">
                    <CardGraphCashFlow
                        @on-chart-rendered="onChartRendered"
                        v-if="chartObject"
                        :chartObject="chartObject"
                        :isVisible="isVisible"
                    />
                </div>
            </div>
        </div>
        <BankAccounts />
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import CardGraphCashFlow from "@/components/dashboard/consolidation/CardGraphCashFlow";
import CardTotalEntity from "@/components/dashboard/consolidation/CardTotalEntity";
import CardTotalTax from "@/components/dashboard/consolidation/CardTotalTax";
import BankAccounts from "@/components/bankAccounts/bankAccounts";
import { consoleHandlerError } from "@/utils/message";

export default {
    name: "Consolidation",
    components: {
        CardTotalTax,
        CardTotalEntity,
        CardGraphCashFlow,
        BankAccounts,
    },
    props: {
        isVisible: Boolean
    },
    methods: {
        onChartRendered() {
            this.$emit('on-chart-rendered');
        },
        ...mapActions("financialEntity", ["getFinanceEntitys"]),
        ...mapMutations("financialEntity", ["SET_IS_ACT_FINANCE_ACC"]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapActions("taxDocument", ["getTotalPay", "getTotalCollect"]),
    },
    computed: {
        ...mapGetters("financialEntity", ["totalFinanceAccounts"]),
        ...mapState("taxDocument", ["totalPay", "totalCollect"]),
        ...mapState("financialEntity", ["isActFinanceAcc", "lastUpdate"]),
        ...mapState("graphCashFlow", ["chartObject"]),
    },
    created() {
        this.getFinanceEntitys();
        this.getTotalPay();
        this.getTotalCollect();
        this.getForecastFlowCash().catch((error) => {
            consoleHandlerError({ error });
        });
    },
};
</script>

<style scoped lang="scss">
// Columna derecha como flex-vertical: el chart wrap toma toda la altura
// remanente del row (que la define la columna izquierda con sus dos cards).
// Sin esto el chart caía a su min-height y dejaba aire vacío al lado de los
// dos summary cards.
.chart_column {
    display: flex;
    flex-direction: column;
}

.chart_wrap {
    flex: 1;
    // min-height: 0 es clave: por default un flex item respeta el min-content
    // de sus hijos (~300px del chart), lo que evita que se encoja por debajo.
    // Forzándolo a 0 permitimos que el chart use exactamente el espacio
    // remanente — ni más ni menos.
    min-height: 0;
    display: flex;
}
</style>
